import { each } from '@antv/util'; // 自定义 Behavior 时候共有的方法

export default {
  getDefaultCfg: function getDefaultCfg() {
    return {};
  },

  /**
   * register event handler, behavior will auto bind events
   * for example:
   * return {
   *  click: 'onClick'
   * }
   */
  getEvents: function getEvents() {
    return {};
  },
  updateCfg: function updateCfg(cfg) {
    Object.assign(this, cfg);
    return true;
  },
  shouldBegin: function shouldBegin() {
    return true;
  },
  shouldUpdate: function shouldUpdate() {
    return true;
  },
  shouldEnd: function shouldEnd() {
    return true;
  },

  /**
   * auto bind events when register behavior
   * @param graph Graph instance
   */
  bind: function bind(graph) {
    var events = this.events;
    this.graph = graph;

    if (this.type === 'drag-canvas' || this.type === 'brush-select' || this.type === 'lasso-select') {
      graph.get('canvas').set('draggable', true);
    }

    each(events, function (handler, event) {
      graph.on(event, handler);
    });
  },
  unbind: function unbind(graph) {
    var events = this.events;

    if (this.type === 'drag-canvas' || this.type === 'brush-select' || this.type === 'lasso-select') {
      graph.get('canvas').set('draggable', false);
    }

    each(events, function (handler, event) {
      graph.off(event, handler);
    });
  },
  get: function get(val) {
    return this[val];
  },
  set: function set(key, val) {
    this[key] = val;
    return this;
  }
};